import FetchHelper from "./FetchHelper";

import AuthManager from "./AuthManager";

export default class Backend {
  static getStats() {
    return FetchHelper.get(
      `${window.Api.Stats}?monthly_stats=true&this_year=true&this_week=true`
    );
  }

  static getDownloadsStats() {
    return FetchHelper.get(`${window.Api.Stats}?daily_downloads=true`);
  }

  static getUnsubscriptionsStats() {
    return FetchHelper.get(`${window.Api.Stats}?daily_unsubscriptions=true`);
  }

  static getRevenueStats() {
    return FetchHelper.get(`${window.Api.Stats}?daily_revenue=true`);
  }

  static getPopularMonthlyFilters() {
    return FetchHelper.get(`${window.Api.Stats}?monthly_popular_filters=true`);
  }

  static getPopularMonthlyTools() {
    return FetchHelper.get(`${window.Api.Stats}?monthly_popular_tools=true`);
  }

  static updateAccount(admin) {
    let data = { ...admin };
    return FetchHelper.patch(`${window.Api.Admins}/${admin.user.id}`, data);
  }

  static getCodesStats() {
    return FetchHelper.get(`${window.Api.Stats}?code_stats=true`);
  }

  static addCode(data) {
    return FetchHelper.post(`${window.Api.Codes}`, data);
  }

  static updateCode(data, id) {
    return FetchHelper.patch(`${window.Api.Codes}/${id}`, data);
  }

  static getPackages() {
    return FetchHelper.get(`${window.Api.Packages}`);
  }
}
